import { Oval } from "react-loader-spinner";

const MarkAsClosedButton = ({ isClosing, onClose, status }) => (
  <button
    className="bg-blueColor text-white text-[10px] font-OpenSansRegular font-[600] px-3 py-[6px] min-w-[110px] rounded-[6px] disabled:opacity-50 flex items-center justify-center"
    onClick={onClose}
    disabled={status === 100 || isClosing}
  >
    {isClosing ? (
      <Oval
        visible={true}
        height="14"
        width="14"
        color="#FFFFFF"
        strokeWidth={8}
        secondaryColor="#FFEEFF"
        ariaLabel="close-ticket-loading"
      />
    ) : (
      "MARK AS CLOSED"
    )}
  </button>
);

export default MarkAsClosedButton;
